// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mr_rime: PokeData = {
  "id": 866,
  "name": "mr-rime",
  "height": 15,
  "weight": 582,
  "base_experience": 182,
  "types": [
    PokeType.ICE,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "pound",
    "double-kick",
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "mimic",
    "light-screen",
    "reflect",
    "protect",
    "icy-wind",
    "safeguard",
    "baton-pass",
    "encore",
    "rapid-spin",
    "mirror-coat",
    "role-play",
    "recycle",
    "teeter-dance",
    "slack-off",
    "fake-tears",
    "block",
    "copycat",
    "sucker-punch",
    "ice-shard",
    "after-you",
    "ally-switch",
    "freeze-dry",
    "misty-terrain",
    "dazzling-gleam"
  ],
  "moves": [
    "double-kick",
    "psychic",
    "reflect",
    "protect",
    "ice-shard",
    "misty-terrain",
    "dazzling-gleam",
    "blizzard",
    "calm-mind",
    "healing-wish",
    "psychic-terrain",
    "synchronize",
    "ice-punch"
  ],
  "evolution_chain": {
    "id": 57,
    "item": {
      "name": "odd-incense"
    },
    "species": [
      {
        "name": "mime-jr",
        "order": 139,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "mr-mime",
        "order": 140,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 439,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "mimic"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "mr-rime",
        "order": 866,
        "types": [
          PokeType.ICE,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 122,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 127,
    "speed": 106,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
